import React, { useEffect, useState } from 'react'
import MainContent from 'src/components/layouts/MainContent'
import MainMenu from 'src/components/layouts/MainMenu'
import PowerBIReport from 'src/components/PowerBI/PowerBIReport'
import { useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Button, Box } from '@mui/material'
import ArrowLeftIcon from '../../components/icons/ArrowLeftIcon'
import { Styles } from '../../types'
import api from '../../api'
import tokens from '../../styles/tokens.json'

const styles: Styles = {
  wrapper: { position: 'relative' },
  section: {
    backgroundColor: tokens.colors.white,
    padding: '0.5rem 6.5rem',
  },
  header: (theme) => ({
    fontFamily: 'Prelo-Light, sans-serif',
    fontSize: '2.25rem',
    lineHeight: '3.5rem',
    color: theme.palette.text.primary,
    paddingBottom: ' 1.5rem',
  }),
  backButton: (theme) => ({
    color: theme.palette.secondary.main,
    padding: 0,
  }),
  link: {
    textDecoration: 'underline',
    padding: '0 0.5rem',
    fontSize: '1rem',
  },
}

const Report = () => {
  const { reportName } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [displayName, setDisplayName] = useState<string>('')

  async function getReportDisplayName() {
    try {
      const response = await api.user.report_GetReportDisplayName(reportName)
      if (response && response.data) {
        setDisplayName(response.data)
      }
    } catch (error) {
      console.error('Failed to fetch report display name:', error)
      setDisplayName('')
    }
  }

  useEffect(() => {
    getReportDisplayName()
  }, [])

  return (
    <>
      <MainMenu currentItem="report" />
      <Box sx={styles.wrapper}>
        <Box sx={styles.section}>
          <Button
            data-testid="Btn_Report_Back"
            onClick={() => navigate('/')}
            sx={styles.backButton}
            role="link">
            <ArrowLeftIcon />
            <Box component="span" sx={styles.link}>
              {t('PowerBI.Report.Back')}
            </Box>
          </Button>
          <Box
            component={'h1' as React.ElementType}
            sx={styles.header}
            title={displayName}
            data-testid={`Hed_Report_${displayName}`}>
            {displayName}
          </Box>
          <MainContent>
            <PowerBIReport reportName={reportName} />
          </MainContent>
        </Box>
      </Box>
    </>
  )
}

export default Report
